<template>
  <el-row class="igt-row">
    <el-col class="adu-col" :sm="12" :xs="24" v-for="(item, index) in items" :key="index">
      <div class="adu-text">
        <div class="adu-img">
          <img :src="require(`@images/${item.img}`)"  />
        </div>
        <h4 class="adu-title">{{item.title}}</h4>
        <el-button @click="handleClickJump" type="primary">{{item.btText}}</el-button>
      </div>
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: "Integration",
  props: {
    items: Array
  },
  methods: {
    handleClickJump() {
      this.$router.push('/contact');
    }
  }
};
</script>
<style lang="scss" scoped>
.igt-row {
  margin: 0 auto;
  margin-top: px2rem(70)!important;
  margin-bottom: 0;
  max-width: px2rem(900);
  .adu-col {
    .adu-text{
      // height: 100%;
      text-align: center;
      max-width: px2rem(260);
      margin: 0 auto;
      width: 90%;
      margin: 0 auto;
      overflow: hidden;
      border: 0px solid rgba(0, 0, 0, 0.2);
      border-radius: 8px;
      box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.1);
      padding: px2rem(15);
      .adu-title {
        font-size: px2rem(18);
        color: $--color-primary;
      }
      .adu-img {
        box-sizing: border-box;
        max-width: px2rem(100);
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .el-button {
        border-radius: px2rem(15);
        padding: px2rem(7) px2rem(22);
      }
    }
  }
}
</style>